// removed by extract-text-webpack-plugin
module.exports = {"ImageViewer":"ModalImageViewer__-loca-__12kcH","Image":"ModalImageViewer__-loca-__dk-Ss"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/ModalImageViewer/ModalImageViewer.css
// module id = 133
// module chunks = 0